// src/routes/ProtectedRoutesWrapper.js
import React, { useEffect, useState } from "react"
import { Routes, Route, Navigate, Outlet, useNavigate } from "react-router-dom"
import ProtectedRouteHeader from "../components/ProtectedRouteHeader"

// Page components
import VisualDashboard from "../protectedRoutes/VisualDashboard"

import { useVariableData } from "../context/VariableDataContext"
import { useAppData } from "../context/AppDataContext"
import LoadingScreen from "../LoadingScreen"
import { toast } from "react-toastify"
import axios from "axios"
import Sidebar from "../components/Sidebar"

const drawerWidth = 240

function DemoLayout({ ALLROUTES }) {
  const [drawerOpen, setDrawerOpen] = useState(false)
  const [isLoadingClients, setIsLoadingClients] = React.useState(false)

  const navigate = useNavigate()
  // const location = useLocation()

  const { setClient, setSelectedClientInfo, selectedClientInfo } = useVariableData()
  const { baseApi } = useAppData()
  const [lastUpdated, setLastUpdated] = useState(null)
  const token = true
  const hasDemoAccess = document.cookie.includes("demo_access=true")

  // 👇 DEMO ORGANIZATION (static)
  const DEMO_ORG = {
    id: 999,
    name: "Demo Organization",
  }
  const user = {
    organization_id: 1,
    organization_name: "Prepaid Recon",
  }

  useEffect(() => {
    if (!hasDemoAccess) return

    const initDemoData = async () => {
      try {
        setSelectedClientInfo({
          id: DEMO_ORG.id,
          label: DEMO_ORG.name,
        })

        setClient(DEMO_ORG.id)

        const res = await axios.get(`${baseApi}/demo/last-updated`)
        if (res.data?.lastUpdated) {
          setLastUpdated(res.data.lastUpdated)
        }
      } catch (err) {
        toast.info("Demo data loaded")
      } finally {
        setIsLoadingClients(false)
      }
    }

    initDemoData()
  }, [hasDemoAccess])

  const routePrefix = "../"

  const lists = ALLROUTES.filter((_r) => _r.forSidebar).reduce(
    (_l, _r) => {
      if (_r.forList === "list2") {
        _l.list2.push({ id: _r.id, disabled: _r.disabled })
      } else {
        _l.list1.push({ id: _r.id, disabled: _r.disabled })
      }

      if (_r.hideSelector) {
        _l.hideSelectorPaths.push(_r.path)
      }

      return _l
    },
    { list1: [], list2: [], hideSelectorPaths: [] }
  )

  const list = lists.list1
  const list2 = lists.list2

  return (
    <>
      {isLoadingClients && (
        <LoadingScreen
          h1={"Loading Demo Data..."}
          style={{
            position: "absolute",
            width: "100%",
            left: 0,
            top: 0,
            backgroundColor: "rgb(0,0,0,0.5)",
            color: "#fff",
          }}
        />
      )}
      <div
        style={{
          marginLeft: drawerOpen ? `${drawerWidth + 19}px` : `83px`,
          position: "fixed",
          top: "0px",
          width: drawerOpen ? `calc(100% - ${drawerWidth + 19}px)` : `calc(100% - 83px)`,
          zIndex: 99,
        }}
      >
        <ProtectedRouteHeader lastUpdated={lastUpdated} client={user.organization_id} />
      </div>

      <Sidebar open={drawerOpen} drawerWidth={drawerWidth} setOpen={setDrawerOpen} onNavigate={navigate} routePrefix={routePrefix} list={list} list2={list2} />

      <div
        style={{
          marginLeft: drawerOpen ? `${drawerWidth}px` : "64px",
          transition: drawerOpen ? "margin 0.3s ease" : "margin 0s",
          width: drawerOpen ? `calc(100% - ${drawerWidth}px)` : "calc(100% - 64px)",
        }}
        className="Va-Main-Content"
      >
        {/* <ProtectedRouteHeader /> */}

        {!isLoadingClients && <Outlet />}
      </div>
    </>
  )
}

export default function ProtectedClientRoutesWrapper() {
  const ALLROUTES = [
    {
      id: "dash",
      forSidebar: true,
      forList: "list1",
      path: "/dashboard",
      component: VisualDashboard,
      hideSelector: false,
    },

    {
      id: "reconciliaion-detail",
      forSidebar: true,
      forList: "list1",
      path: "/reconciliaion-detail",
      component: VisualDashboard,
      hideSelector: false,
      disabled: true,
    },
    {
      id: "appeals-detail",
      forSidebar: true,
      forList: "list1",
      path: "/appeals-detail",
      component: VisualDashboard,
      hideSelector: false,
      disabled: true,
    },

    {
      id: "client",
      forSidebar: true,
      forList: "list1",
      path: "/client",
      component: VisualDashboard,
      hideSelector: false,
      disabled: true,
    },
    {
      id: "daily-sales-report",
      forSidebar: true,
      forList: "list1",
      path: "/dsr",
      component: VisualDashboard,
      hideSelector: false,
      disabled: true,
    },
    {
      id: "profile",
      forSidebar: true,
      forList: "list2",
      path: "/profile",
      component: VisualDashboard,
      hideSelector: true,
      disabled: true,
    },
    {
      id: "settings",
      forSidebar: true,
      forList: "list2",
      path: "/settings",
      component: VisualDashboard,
      hideSelector: true,
      disabled: true,
    },
  ]

  return (
    <Routes>
      <Route element={<DemoLayout ALLROUTES={ALLROUTES} />}>
        {ALLROUTES.map((_R) => (
          <Route path={_R.path} element={<_R.component />} />
        ))}

        <Route path="/*" element={<Navigate to="/dashboard" replace />} />
      </Route>
    </Routes>
  )
}
